//src/admin/pages/AdminDiscounts.js
import React, { useState, useContext } from "react";
import { useRef, useEffect } from "react";
import {
  FiTag,
  FiShoppingCart,
  FiPercent,
  FiTruck,
  FiCopy,
} from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { FaTag } from "react-icons/fa";
import { getAdminDiscounts } from "../../services/adminDiscounts.api";
import { FaPen } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { deleteAdminDiscount } from "../../services/adminDiscounts.api";
import { deleteAdminCoupon } from "../../services/adminCoupons.api";

function AdminDiscounts() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { lang } = useContext(AdminLanguageContext);

  const [modalOpen, setModalOpen] = useState(false);
  const modalRef = useRef();

  const [page, setPage] = useState(1);
  const pageSize = 6;

  const [copiedId, setCopiedId] = useState(null);

  // 👉 later this will come from API
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [valueOverlay, setValueOverlay] = useState(null);
const [appliesOverlay, setAppliesOverlay] = useState(null);
const [eligibilityOverlay, setEligibilityOverlay] = useState(null);

  const [deleteModal, setDeleteModal] = useState(null);
  const [deleting, setDeleting] = useState(false);
  
useEffect(() => {
  setLoading(true);

  getAdminDiscounts()
    .then(setDiscounts)
    .catch(console.error)
    .finally(() => setLoading(false));
}, []);

useEffect(() => {
  const maxPage = Math.ceil(discounts.length / pageSize);
  if (page > maxPage) {
    setPage(maxPage || 1);
  }
}, [discounts]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".applies-overlay") &&
      !e.target.closest(".applies-trigger")
    ) {
      setAppliesOverlay(null);
    }

    if (
      !e.target.closest(".eligibility-overlay") &&
      !e.target.closest(".eligibility-trigger")
    ) {
      setEligibilityOverlay(null);
    }
  };

  if (appliesOverlay || valueOverlay || eligibilityOverlay) {
    document.addEventListener("click", handleClick);
  }

  return () => document.removeEventListener("click", handleClick);
}, [appliesOverlay, valueOverlay, eligibilityOverlay]);

  const TEXT = {
    EN: {
      title: "Discounts",
      create: "Create discount",
      emptyTitle: "Manage discounts and promotions",
      emptyText:
        "Add discount codes and automatic discounts that apply at checkout. You can also use discounts with compare at prices.",
    },
    AR: {
      title: "الخصومات",
      create: "إنشاء خصم",
      emptyTitle: "إدارة الخصومات والعروض",
      emptyText:
        "أضف أكواد خصم وخصومات تلقائية تطبق عند الدفع. يمكنك أيضًا استخدام الخصومات مع الأسعار المقارنة.",
    },
  }[lang];

  const paginatedDiscounts = discounts.slice(
  (page - 1) * pageSize,
  page * pageSize
);

 const copyCode = async (e, code, id) => {
  e.stopPropagation();

  try {
    await navigator.clipboard.writeText(code);

    setCopiedId(id);

    setTimeout(() => {
      setCopiedId(null);
    }, 1500);
  } catch (err) {
    console.error("Copy failed:", err);
  }
};

const getDiscountEditPath = (discount) => {

  if (discount.is_coupon) {
  return `/admin/discounts/create-discount-code/${discount.id}`;
}

if (discount.discount_type === "free_shipping") {
  return `/admin/discounts/create-shipping-discount/${discount.id}`;
}

  const isBxgy = discount.discount_type === "bxgy";

  const isOrderDiscount =
    !isBxgy &&
    discount.products_count === 0 &&
    discount.categories_count === 0;

  if (isBxgy) {
    return `/admin/discounts/create-bxgy-discount/${discount.id}`;
  }

  if (isOrderDiscount) {
    return `/admin/discounts/create-order-discount/${discount.id}`;
  }

  return `/admin/discounts/create-bulk-discount/${discount.id}`;
};

 useEffect(() => {
  const handleMouseDown = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setModalOpen(false);
    }
  };

  if (modalOpen) {
    document.addEventListener("mousedown", handleMouseDown);
  }

  return () => {
    document.removeEventListener("mousedown", handleMouseDown);
  };
}, [modalOpen]);

const parseEligibilityCustomers = (discount) => {
  const raw = String(discount.eligibility_customers_raw || "").trim();

  if (!raw) return [];

  return raw
    .split("||")
    .map((item) => {
      const [id, name, email, phone] = item.split("::");

      return {
        id,
        name: name || "",
        email: email || "",
        phone: phone || "",
      };
    })
    .filter((customer) => customer.id);
};

const isProductOrCollectionDiscount = (discount) => {
  if (discount.is_coupon) return false;
  if (discount.discount_type === "bxgy") return false;
  if (discount.discount_type === "free_shipping") return false;

  return (
    Number(discount.products_count || 0) > 0 ||
    Number(discount.categories_count || 0) > 0
  );
};

const supportsEligibilityColumn = (discount) => {
  return discount.is_coupon || isProductOrCollectionDiscount(discount);
};

const getEligibilityCustomers = (discount) => {
  if (!supportsEligibilityColumn(discount)) return [];
  return parseEligibilityCustomers(discount);
};

const getEligibilityLabel = (discount) => {
  if (!supportsEligibilityColumn(discount)) {
    return lang === "AR" ? "كل العملاء" : "All customers";
  }

  const customers = getEligibilityCustomers(discount);

  if (!customers.length) {
    return lang === "AR" ? "كل العملاء" : "All customers";
  }

  if (customers.length === 1) {
    return customers[0].name || customers[0].phone || customers[0].email || "Customer";
  }

  return lang === "AR"
    ? `${customers.length} عملاء`
    : `${customers.length} customers`;
};

  return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""}`}>
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6">

          {/* HEADER */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">

            {/* LEFT */}
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center">
  <img
    src="/icons/discountNotSelected.png"
    alt="discount"
    className="w-[18px] h-[18px] object-contain"
  />
</div>

              <h1 className="text-[20px] font-semibold text-gray-900">
                {TEXT.title}
              </h1>
            </div>

            {/* RIGHT */}
            <button
              onClick={() => setModalOpen(true)}
              className="
              h-10 sm:h-8 w-full sm:w-auto px-3
              bg-[#1f1f1f]
              text-white
              rounded-lg
              text-sm font-medium
              hover:bg-black
              transition
              "
            >
              {TEXT.create}
            </button>

          </div>

          {/* EMPTY STATE */}
      {loading ? (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] p-4 animate-pulse">

    {/* HEADER */}
    <div className="h-4 w-32 bg-gray-200 rounded mb-4"></div>

    {/* ROWS */}
    {[...Array(6)].map((_, i) => (
      <div key={i} className="flex items-center gap-4 py-3 border-b">

        <div className="w-6 h-6 bg-gray-200 rounded"></div>

        <div className="flex-1 space-y-2">
          <div className="h-3 w-1/3 bg-gray-200 rounded"></div>
          <div className="h-3 w-1/4 bg-gray-200 rounded"></div>
        </div>

        <div className="h-3 w-16 bg-gray-200 rounded"></div>
        <div className="h-3 w-16 bg-gray-200 rounded"></div>

      </div>
    ))}

  </div>
): discounts.length === 0 ? (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-sm p-10 sm:p-14 flex flex-col items-center text-center">
    <div className="w-20 h-20 rounded-full bg-[#f6f6f7] flex items-center justify-center mb-5">
      <FaTag className="text-[#6d7175] text-[34px]" />
    </div>

    <h2 className="text-[18px] font-semibold text-[#202223] mb-2">
      {TEXT.emptyTitle}
    </h2>

    <p className="max-w-[520px] text-[14px] leading-6 text-[#6d7175] mb-6">
      {TEXT.emptyText}
    </p>

<p className="text-xs text-gray-400 mb-6">
  {lang === "AR"
    ? "ابدأ بإنشاء أول خصم لك"
    : "Start by creating your first discount"}
</p>

    <button
      onClick={() => setModalOpen(true)}
      className="
        h-10 px-5
        bg-[#1f1f1f]
        text-white
        rounded-lg
        text-sm font-medium
        hover:bg-black
        transition
      "
    >
      {TEXT.create}
    </button>
  </div>
) : (
  <div className="
    bg-white
    border border-[#e3e3e3]
    rounded-[14px]
    overflow-visible
    shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
  ">

    {/* TABLE HEADER */}
    <div className="px-4 py-3 border-b bg-white flex justify-between items-center rounded-t-[14px]">

      <div className="text-sm text-gray-500">
        {discounts.length} {lang === "AR" ? "خصومات" : "discounts"}
      </div>

    </div>

    <div className="hidden sm:block">
  <table className="w-full text-center text-[13px] rounded-b-[14px]">
      {/* HEAD */}
      <thead className="bg-[#f6f6f7] text-[#6d7175]">
        <tr>
          <th className="py-2"></th>
          <th className="py-2">{lang === "AR" ? "النوع" : "Type"}</th>
          <th>{lang === "AR" ? "القيمة" : "Value"}</th>
          <th>{lang === "AR" ? "يُطبق على" : "Applies to"}</th>
<th>{lang === "AR" ? "الأهلية" : "Eligibility"}</th>
<th>{lang === "AR" ? "تاريخ البدء" : "Start"}</th>
          <th>{lang === "AR" ? "تاريخ الانتهاء" : "End"}</th>
          <th>{lang === "AR" ? "الحالة" : "Status"}</th>
          <th>{lang === "AR" ? "حذف" : "Delete"}</th>
        </tr>
      </thead>

      {/* BODY */}
      <tbody>
        {discounts.map((d) =>{
          const isActive =
                  d.is_active === 1 &&
                  (!d.end_at || new Date(d.end_at) > new Date());

          return (
            <tr
                key={d.id}
                onClick={(e) => {
                          // ❌ prevent navigation if clicking overlay triggers
                          if (
                            e.target.closest(".applies-trigger") ||
                            e.target.closest(".value-trigger")
                          ) {
                            return;
                          }

                          navigate(getDiscountEditPath(d));
                        }}
                className="group border-b hover:bg-[#f6f6f7] transition cursor-pointer"
              >
{/* ICON */}
<td className="py-2">
  {(() => {

    if (d.is_coupon) {
      return (
        <span className="flex items-center justify-center w-6 h-6 rounded bg-indigo-100 text-indigo-700 mx-auto">
          <FiTag className="text-[14px]" />
        </span>
      );
    }

    if (d.discount_type === "free_shipping") {
  return (
    <span className="flex items-center justify-center w-6 h-6 rounded bg-orange-100 text-orange-700 mx-auto">
      <FiTruck className="text-[14px]" />
    </span>
  );
}

    if (d.discount_type === "bxgy") {
      return (
        <span className="flex items-center justify-center w-6 h-6 rounded bg-purple-100 text-purple-700 mx-auto">
          <FiShoppingCart className="text-[14px]" />
        </span>
      );
    }

    const isOrder =
      d.products_count === 0 && d.categories_count === 0;

    if (isOrder) {
      return (
        <span className="flex items-center justify-center w-6 h-6 rounded bg-blue-100 text-blue-700 mx-auto">
          <FiPercent className="text-[14px]" />
        </span>
      );
    }

    return (
      <span className="flex items-center justify-center w-6 h-6 rounded bg-green-100 text-green-700 mx-auto">
        <FiTag className="text-[14px]" />
      </span>
    );
  })()}
</td>
              {/* TYPE */}
          <td className="py-2">
  {(() => {

if (d.is_coupon) {
  return (
    <div className="flex flex-col items-center gap-1">

      {/* TITLE */}
      <span className="text-gray-900 font-medium">
        {lang === "AR" ? "كود خصم" : "Discount code"}
      </span>

      {/* CODE BADGE */}
      <button
        type="button"
        onClick={(e) => copyCode(e, d.code, d.id)}
        className="
          flex items-center gap-2
          px-2.5 py-[3px]
          bg-[#f6f6f7]
          border border-[#e1e3e5]
          rounded-md
          text-[11px] font-mono
          text-gray-800
          hover:bg-[#eeeeef]
          transition
        "
      >
        <span>{d.code}</span>

        {copiedId === d.id ? (
          <span className="text-green-600 text-[11px]">✓</span>
        ) : (
          <FiCopy className="text-[11px] text-gray-500" />
        )}
      </button>

    </div>
  );
}

if (d.discount_type === "free_shipping") {
  return (
    <span className="text-gray-900 font-medium">
      {lang === "AR" ? "شحن مجاني" : "Free shipping"}
    </span>
  );
}

    const isBxgy = d.discount_type === "bxgy";

    const isOrderDiscount =
  !isBxgy &&
  d.products_count === 0 &&
  d.categories_count === 0;

    // ✅ BXGY
    if (isBxgy) {
      return (
  <span className="text-gray-900 font-medium">
    {lang === "AR"
  ? `اشترِ ${d.buy_qty} واحصل على ${d.get_qty}`
  : `Buy ${d.buy_qty} Get ${d.get_qty}`
}
  </span>
);
    }

    // ✅ ORDER
    if (isOrderDiscount) {
      return (
  <span className="text-gray-900 font-medium">
    {lang === "AR" ? "خصم على الطلب" : "Order discount"}
  </span>
);
    }

    // ✅ PRODUCT
    return (
  <span className="text-gray-900 font-medium">
    {lang === "AR" ? "خصم على المنتجات" : "Product discount"}
  </span>
);
  })()}
</td>

              {/* VALUE */}
             <td className="text-gray-900 font-medium">
  {d.discount_type === "free_shipping" ? (
    lang === "AR" ? "مجاني" : "Free"
  ) : d.is_coupon ? (
    d.discount_type === "fixed"
      ? `$${d.discount_value}`
      : `${d.discount_value}%`
  ) : d.discount_type === "bxgy" ? (
    d.get_discount_type === "free"
      ? lang === "AR" ? "مجاني" : "Free"
      : `${d.get_discount_value}%`
  ) : d.discount_type === "fixed" ? (
    `$${d.discount_value}`
  ) : (
    `${d.discount_value}%`
  )}
</td>

              {/* APPLIES */}
              <td
  className="applies-trigger relative cursor-pointer hover:bg-gray-300 transition"
  onClick={(e) => {
    e.stopPropagation();
    setAppliesOverlay(d.id === appliesOverlay?.id ? null : d);
  }}
>
  <div className="flex items-center justify-center gap-1">
   <span>
  {(() => {
  const isBxgy = d.discount_type === "bxgy";

  const isOrderDiscount =
  !isBxgy &&
  d.products_count === 0 &&
  d.categories_count === 0;

  if (d.is_coupon) {
  return lang === "AR" ? "عند الدفع" : "At checkout";
}

  if (isBxgy) {
    return lang === "AR" ? "منتجات محددة" : "Selected products";
  }

  if (isOrderDiscount) {
    if (d.min_requirement === "none") {
      return lang === "AR" ? "كل الطلبات" : "All orders";
    }

    if (d.min_requirement === "amount") {
      return `${lang === "AR" ? "طلبات بقيمة أكثر من" : "Orders over"} $${d.min_amount}`;
    }

    if (d.min_requirement === "qty") {
      return `${lang === "AR" ? "طلبات تحتوي على" : "Orders with"} ${d.min_qty}+`;
    }
  }

  return lang === "AR" ? "منتجات / مجموعات" : "Products / Collections";
})()}
</span>

   <span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
     <FiChevronDown className="text-[16px]" />
   </span>
 </div>

  {appliesOverlay?.id === d.id && (
    <div
      className="
      applies-overlay
      absolute
      left-0 sm:left-1/2 sm:-translate-x-1/2
w-full sm:w-[240px]
      top-full
      pt-2
      w-[240px]
      bg-white
      border border-gray-200
      rounded-[14px]
      shadow-[0_25px_60px_rgba(0,0,0,0.20)]
      z-50
      animate-sortOverlay
      "
      onClick={(e) => e.stopPropagation()}
    >

      {/* HEADER */}
      <div className="px-4 pt-3 pb-2 border-b">
        <div className="text-sm font-semibold text-gray-900">
          {d.is_coupon
  ? (lang === "AR" ? "الاستخدام" : "Usage")
  : (lang === "AR" ? "التطبيق" : "Applies to")}
        </div>
      </div>

      {/* CONTENT */}
      <div className="px-4 py-3 space-y-2 text-sm">

    {(() => {

    if (d.is_coupon) {
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-gray-500">
        <span>{lang === "AR" ? "عدد مرات الاستخدام" : "Times used"}</span>
        <span>{Number(d.used_count || 0)}</span>
      </div>

      <div className="flex justify-between text-gray-500">
        <span>{lang === "AR" ? "حد الاستخدام" : "Usage limit"}</span>
        <span>
          {d.max_uses
            ? Number(d.max_uses)
            : (lang === "AR" ? "غير محدود" : "Unlimited")}
        </span>
      </div>
    </div>
  );
}

  const isBxgy = d.discount_type === "bxgy";

  const isOrderDiscount =
  !isBxgy &&
  d.products_count === 0 &&
  d.categories_count === 0;

  // ✅ BXGY
  if (isBxgy) {
    return (
      <>
        {(d.bxgy_products || "").split(",").map((item, i) => {
          const [id, role] = item.split(":");

          return (
            <div key={i} className="flex justify-between text-gray-500">
              <span>
                {role === "buy"
                  ? (lang === "AR" ? "شراء" : "Buy")
                  : (lang === "AR" ? "احصل" : "Get")}
              </span>
              <span>{id}</span>
            </div>
          );
        })}
      </>
    );
  }

  // ✅ ORDER DISCOUNT
  if (isOrderDiscount) {
    return (
      <div className="flex justify-between text-gray-500">
        <span>{lang === "AR" ? "الشرط" : "Requirement"}</span>
        <span>
          {d.min_requirement === "none"
            ? (lang === "AR" ? "لا يوجد" : "None")
            : d.min_requirement === "amount"
              ? `$${d.min_amount}`
              : lang === "AR"
  ? `${d.min_qty} منتجات`
  : `${d.min_qty} items`}
        </span>
      </div>
    );
  }

  // ✅ PRODUCT DISCOUNT
  return (
    <>
      <div className="flex justify-between text-gray-500">
        <span>{lang === "AR" ? "منتجات" : "Products"}</span>
        <span>{d.products_count || 0}</span>
      </div>

      <div className="flex justify-between text-gray-500">
        <span>{lang === "AR" ? "فئات" : "Categories"}</span>
        <span>{d.categories_count || 0}</span>
      </div>
    </>
  );
})()}
      </div>
      <div className="border-t"></div>

<div className="p-2">
  <button
    onClick={(e) => {
      e.stopPropagation();
      navigate(getDiscountEditPath(d));
    }}
    className="
    w-full
    flex items-center justify-center gap-2
    h-[34px]
    bg-[#f6f6f7]
    border border-gray-300
    rounded-lg
    text-[13px] font-medium text-gray-800
    shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
    hover:bg-gray-100
    active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
    transition
    "
  >
    <FaPen className="text-[12px] text-gray-600" /> {lang === "AR" ? "تعديل الخصم" : "Edit discount"}
  </button>
</div>
    </div>
  )}
</td>
{/* ELIGIBILITY */}
<td
  className={`
    eligibility-trigger
    relative
    transition
    ${
      getEligibilityCustomers(d).length > 1
        ? "cursor-default hover:bg-gray-300"
        : ""
    }
  `}
  onMouseEnter={() => {
    const customers = getEligibilityCustomers(d);
    if (customers.length > 1) {
      setEligibilityOverlay(d);
    }
  }}
  onMouseLeave={() => {
    setEligibilityOverlay(null);
  }}
>
  <div className="flex items-center justify-center gap-1">
    <span className="text-gray-900 font-medium">
      {getEligibilityLabel(d)}
    </span>

    {getEligibilityCustomers(d).length > 1 && (
      <span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
        <FiChevronDown className="text-[16px]" />
      </span>
    )}
  </div>

  {eligibilityOverlay?.id === d.id && getEligibilityCustomers(d).length > 1 && (
    <div
      className="
        eligibility-overlay
        absolute
        left-0 sm:left-1/2 sm:-translate-x-1/2
        top-full
        mt-2
        w-[260px]
        bg-white
        border border-gray-200
        rounded-[14px]
        shadow-[0_25px_60px_rgba(0,0,0,0.20)]
        z-50
        animate-sortOverlay
        text-left
      "
      onClick={(e) => e.stopPropagation()}
    >
      <div className="px-4 pt-3 pb-2 border-b">
        <div className="text-sm font-semibold text-gray-900">
          {lang === "AR" ? "العملاء المسموح لهم" : "Allowed customers"}
        </div>
      </div>

      <div className="max-h-[220px] overflow-y-auto px-3 py-2 space-y-1">
        {getEligibilityCustomers(d).map((customer) => (
          <div
            key={customer.id}
            className="px-2 py-2 rounded-lg hover:bg-gray-50"
          >
            <div className="text-[13px] font-medium text-gray-900 truncate">
              {customer.name || customer.phone || customer.email || "Customer"}
            </div>

            {(customer.phone || customer.email) && (
              <div className="text-[11px] text-gray-500 truncate">
                {customer.phone || customer.email}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )}
</td>
              {/* START */}
              <td className="text-gray-500">
                {
                  d.start_at
                    ? new Date(d.start_at).toLocaleDateString()
                    : new Date(d.created_at).toLocaleDateString()
                }
              </td>

              {/* END */}
              <td className="text-gray-500">
                {
                    d.end_at &&
new Date(d.end_at).toISOString().startsWith("2099-12-31")
  ? (lang === "AR" ? "بدون تاريخ انتهاء" : "Permanent")
  : d.end_at
    ? new Date(d.end_at).toLocaleDateString()
    : (lang === "AR" ? "بدون تاريخ انتهاء" : "Permanent")
                  }
              </td>

              {/* STATUS */}
              <td>
                <span
                  className={`
                        text-[11px] px-2.5 py-[2px] rounded-md font-medium
                        ${
                          d.is_active === 0
                            ? "bg-gray-100 text-gray-600"
                            : (!d.end_at || new Date(d.end_at) > new Date())
                              ? "bg-green-50 text-green-700"
                              : "bg-orange-50 text-orange-700"
                        }
                      `}
                >
                  {d.is_active === 0
                          ? (lang === "AR" ? "غير نشط" : "Inactive")
                          : (!d.end_at || new Date(d.end_at) > new Date())
                            ? (lang === "AR" ? "نشط" : "Active")
                            : (lang === "AR" ? "منتهي" : "Expired")}
                </span>
              </td>
<td
  onClick={(e) => {
    e.stopPropagation();
    setDeleteModal(d);
  }}
  className="cursor-pointer hover:bg-red-50 transition"
>
  <span className="text-red-500 text-[12px] font-medium">
    {lang === "AR" ? "حذف" : "Delete"}
  </span>
</td>
            </tr>
          );
        })}
      </tbody>

    </table>
</div>

{/* ================= MOBILE CARDS ================= */}
<div className="sm:hidden space-y-3 p-3">
  {paginatedDiscounts.map((d) =>{
    const isActive =
      d.is_active === 1 &&
      (!d.end_at || new Date(d.end_at) > new Date());

    return (
      <div
        key={d.id}
        onClick={() => navigate(getDiscountEditPath(d))}
        className="bg-white border rounded-xl p-3 shadow-sm space-y-2 active:scale-[0.99] transition"
      >
        {/* TOP */}
        <div className="flex justify-between items-start">

          {/* LEFT */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-100">
              {d.discount_type === "free_shipping" ? <FiTruck /> :
               d.discount_type === "bxgy" ? <FiShoppingCart /> :
               d.products_count === 0 && d.categories_count === 0 ? <FiPercent /> :
               <FiTag />}
            </div>

            <div className="text-sm font-medium text-gray-900">
              {d.is_coupon
                ? (lang === "AR" ? "كود خصم" : "Discount code")
                : d.discount_type === "free_shipping"
                ? (lang === "AR" ? "شحن مجاني" : "Free shipping")
                : d.discount_type === "bxgy"
                ? (lang === "AR"
                    ? `اشترِ ${d.buy_qty} واحصل على ${d.get_qty}`
                    : `Buy ${d.buy_qty} Get ${d.get_qty}`)
                : d.products_count === 0 && d.categories_count === 0
                ? (lang === "AR" ? "خصم على الطلب" : "Order discount")
                : (lang === "AR" ? "خصم على المنتجات" : "Product discount")}
            </div>
          </div>

          {/* STATUS */}
          <span
            className={`text-[10px] px-2 py-[2px] rounded-md font-medium
              ${
                d.is_active === 0
                  ? "bg-gray-100 text-gray-600"
                  : (!d.end_at || new Date(d.end_at) > new Date())
                  ? "bg-green-50 text-green-700"
                  : "bg-orange-50 text-orange-700"
              }
            `}
          >
            {d.is_active === 0
              ? (lang === "AR" ? "غير نشط" : "Inactive")
              : (!d.end_at || new Date(d.end_at) > new Date())
              ? (lang === "AR" ? "نشط" : "Active")
              : (lang === "AR" ? "منتهي" : "Expired")}
          </span>
        </div>

        {/* VALUE */}
        <div className="text-sm text-gray-900">
          <span className="text-gray-400">
            {lang === "AR" ? "القيمة: " : "Value: "}
          </span>

          {
  d.discount_type === "free_shipping" ? (
    lang === "AR" ? "مجاني" : "Free"
  ) : d.discount_type === "bxgy" ? (
    d.get_discount_type === "free"
      ? (lang === "AR" ? "مجاني" : "Free")
      : `${d.get_discount_value}%`
  ) : d.discount_type === "fixed" ? (
    `$${d.discount_value}`
  ) : (
    `${d.discount_value}%`
  )
}
        </div>
{/* ELIGIBILITY */}
<div className="text-sm text-gray-900">
  <span className="text-gray-400">
    {lang === "AR" ? "الأهلية: " : "Eligibility: "}
  </span>

  {getEligibilityLabel(d)}
</div>

{getEligibilityCustomers(d).length > 1 && (
  <div className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 space-y-1">
    {getEligibilityCustomers(d).map((customer) => (
      <div key={customer.id} className="text-xs text-gray-600">
        <span className="font-medium text-gray-800">
          {customer.name || customer.phone || customer.email || "Customer"}
        </span>
        {(customer.phone || customer.email) && (
          <span className="text-gray-400">
            {" "}
            — {customer.phone || customer.email}
          </span>
        )}
      </div>
    ))}
  </div>
)}
        {/* DATES */}
        <div className="text-xs text-gray-500 flex justify-between">
          <span>
            {lang === "AR" ? "من: " : "From: "}
            {new Date(d.start_at || d.created_at).toLocaleDateString()}
          </span>

          <span>
            {lang === "AR" ? "إلى: " : "To: "}
            {d.end_at
              ? new Date(d.end_at).toLocaleDateString()
              : (lang === "AR" ? "بدون تاريخ انتهاء" : "Permanent")}
          </span>
        </div>

        {/* DELETE */}
        <button
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    setDeleteModal(d);
  }}
          className="text-red-500 text-xs font-medium"
        >
          {lang === "AR" ? "حذف" : "Delete"}
        </button>

      </div>
    );
  })}
  <div className="flex justify-center items-center gap-2 mt-4">

  <button
    disabled={page === 1}
    onClick={() => setPage(p => p - 1)}
    className="px-3 py-1 text-sm border rounded disabled:opacity-40"
  >
    {lang === "AR" ? "السابق" : "Prev"}
  </button>

  <span className="text-sm text-gray-500">
  {page} / {Math.max(1, Math.ceil(discounts.length / pageSize))}
</span>

  <button
    disabled={page * pageSize >= discounts.length}
    onClick={() => setPage(p => p + 1)}
    className="px-3 py-1 text-sm border rounded disabled:opacity-40"
  >
    {lang === "AR" ? "التالي" : "Next"}
  </button>

</div>
</div>

  </div>
)}

{modalOpen && (
  <div
    className="fixed inset-0 z-[999] bg-black/40 flex items-center justify-center"
    onClick={() => setModalOpen(false)}
  >
    <div
      ref={modalRef}
      onClick={(e) => e.stopPropagation()}
      className="
        w-[95%] max-w-lg
        bg-white
        rounded-2xl
        shadow-[0_20px_60px_rgba(0,0,0,0.25)]
        animate-fadeSlide
      "
    >

      {/* HEADER */}
      <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-100 rounded-t-2xl">
        <h2 className="text-lg font-semibold text-gray-900">
          {lang === "AR" ? "اختر نوع الخصم" : "Select discount type"}
        </h2>

        <button
          onClick={() => setModalOpen(false)}
          className="text-gray-500 hover:text-black text-sm"
        >
          ✕
        </button>
      </div>

      {/* BODY */}
      <div className="divide-y">

        {/* ROW 1 */}
        <button
          onClick={() => {
              setModalOpen(false);
              navigate("/admin/discounts/create-bulk-discount");
            }}
          className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition"
        >
          <div className="flex items-start gap-3 text-left">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 text-green-700">
              <FiTag />
            </div>

            <div>
              <div className="font-medium text-gray-900">
                {lang === "AR" ? "خصم على المنتجات" : "Amount off products"}
              </div>
              <div className="text-sm text-gray-500">
                {lang === "AR"
                  ? "خصم على منتجات أو مجموعات محددة"
                  : "Discount specific products or collections of products"}
              </div>
            </div>
          </div>

          <FiChevronRight />
        </button>

        {/* ROW 2 */}
        <button 
        onClick={() => {
  setModalOpen(false);
  navigate("/admin/discounts/create-bxgy-discount");
}}
        className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50">
          <div className="flex items-start gap-3 text-left">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-purple-100 text-purple-700">
              <FiShoppingCart />
            </div>

            <div>
              <div className="font-medium">
                {lang === "AR" ? "اشترِ X واحصل على Y" : "Buy X get Y"}
              </div>
              <div className="text-sm text-gray-500">
                {lang === "AR"
                  ? "خصم على منتجات أو مجموعات محددة"
                  : "Discount specific products or collections of products"}
              </div>
            </div>
          </div>

          <FiChevronRight />
        </button>

        {/* ROW 3 */}
        <button
  onClick={() => {
    setModalOpen(false);
    navigate("/admin/discounts/create-order-discount");
  }}
  className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50"
>
          <div className="flex items-start gap-3 text-left">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-blue-100 text-blue-700">
              <FiPercent />
            </div>

            <div>
              <div className="font-medium">
                {lang === "AR" ? "خصم على الطلب" : "Amount off order"}
              </div>
              <div className="text-sm text-gray-500">
                {lang === "AR" ? "تخفيض إجمالي الطلب" : "Discount the total order amount"}
              </div>
            </div>
          </div>

          <FiChevronRight />
        </button>

        {/* ROW 4 */}
        <button
  onClick={() => {
    setModalOpen(false);
    navigate("/admin/discounts/create-shipping-discount");
  }}
  className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50"
>
          <div className="flex items-start gap-3 text-left">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-orange-100 text-orange-700">
              <FiTruck />
            </div>

            <div>
              <div className="font-medium">
                {lang === "AR" ? "شحن مجاني" : "Free shipping"}
              </div>
              <div className="text-sm text-gray-500">
                {lang === "AR"
                  ? "تقديم شحن مجاني على الطلب"
                  : "Offer free shipping on an order"}
              </div>
            </div>
          </div>

          <FiChevronRight />
        </button>

{/* ROW 5 - PROMO CODE */}
<button
onClick={() => {
    setModalOpen(false);
    navigate("/admin/discounts/create-discount-code");
  }}
  className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition"
>
  <div className="flex items-start gap-3 text-left">
    
    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-indigo-100 text-indigo-700">
      <FiTag />
    </div>

    <div>
      <div className="font-medium text-gray-900">
        {lang === "AR" ? "كود خصم" : "Discount code"}
      </div>

      <div className="text-sm text-gray-500">
        {lang === "AR"
          ? "إنشاء كود يتم إدخاله عند الدفع"
          : "Create a code customers enter at checkout"}
      </div>
    </div>

  </div>

  <FiChevronRight />
</button>

      </div>

      {/* FOOTER */}
      <div className="flex justify-end px-5 py-4 border-t bg-gray-100 rounded-b-2xl">
        <button
          onClick={() => setModalOpen(false)}
          className="
            px-4 py-2
            bg-white
            border border-gray-300
            rounded-lg
            text-sm font-medium
            hover:bg-gray-50
          "
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>
      </div>

    </div>
  </div>
)}
{deleteModal && (
  <div className="fixed inset-0 bg-black/50 z-[999] flex items-center justify-center">
    <div className="w-full max-w-[400px] bg-white rounded-[18px] p-5">

      <h3 className="font-semibold text-lg mb-2">
        {lang === "AR" ? "حذف الخصم" : "Delete discount"}
      </h3>

      <p className="text-sm text-gray-600 mb-5">
        {lang === "AR"
          ? "هل أنت متأكد؟ سيتم إزالة الخصم من جميع المنتجات."
          : "Are you sure? This will remove the discount from all products."}
      </p>

      <div className="flex justify-end gap-3">

        <button
          onClick={() => setDeleteModal(null)}
          className="px-4 py-2 border rounded"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={async () => {
            try {
              setDeleting(true);

              if (deleteModal.is_coupon) {
  await deleteAdminCoupon(deleteModal.id);
} else {
  await deleteAdminDiscount(deleteModal.id);
}

              // ✅ remove from UI instantly
              setDiscounts(prev =>
                prev.filter(d => d.id !== deleteModal.id)
              );

              setDeleteModal(null);
            } catch (e) {
  console.error(e);

  alert(
    lang === "AR"
      ? "لا يمكن حذف هذا الكود لأنه تم استخدامه في طلبات سابقة. يمكنك جعله غير نشط بدلاً من حذفه."
      : "This coupon cannot be deleted because it was already used in previous orders. You can deactivate it instead."
  );
} finally {
              setDeleting(false);
            }
          }}
          className={`
            px-4 py-2 rounded text-white
            ${deleting ? "bg-gray-400" : "bg-red-600 hover:bg-red-700"}
          `}
        >
          {deleting
            ? (lang === "AR" ? "جارٍ الحذف..." : "Deleting...")
            : (lang === "AR" ? "تأكيد" : "Confirm")}
        </button>

      </div>
    </div>
  </div>
)}
        </main>
      </div>
    </div>
  );
}

export default AdminDiscounts;